import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useArchiveSession } from '@/features/model-training'
import { requirePermission } from '@/shared/auth'
import { AppShell } from '@/widgets/layouts/app-shell'

export const Route = createFileRoute('/app')({
  beforeLoad: requirePermission('app:view'),
  component: AppLayout,
})

function AppLayout() {
  // An archive of datasets being followed belongs to the user who asked for it.
  useArchiveSession()
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
